/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-restricted-syntax */
import lodash from 'lodash'
import moment from 'moment'
import { toast } from 'react-toastify'
import { combineEpics } from 'redux-observable'
import { concat, EMPTY, of } from 'rxjs'
import { fromPromise } from 'rxjs/internal-compatibility'
import { catchError, delay, filter, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators'
import { IReply } from 'src/models/disciplineOverview/disciplineOverview'
import {
	getAssetByTagCode,
	GetDisciplines,
	GetHistory,
	getTIDPData,
	PostQuery,
	saveAsset,
	saveNewAssetComment,
} from 'src/services/tidpOverview'
import { isOfType } from 'typesafe-actions'
import { dateFormat } from '../../assets/dateFormats'
import browserHistory from '../../services/history'
import { AppEpicDeprecated } from '../../utils/reduxUtils'
import { authorizationActions } from '../authorization'
import { controlsActions } from '../controls'
import { tasksActionsElementActions } from '../taskActions'
import {
	addAnotherRevision,
	duplicateTidp,
	getListOfDisciplines,
	getTidpHistory,
	getTidpOverview,
	getTidpStatus,
	getTidpStatusSilent,
	refreshTidpNumber,
	saveNewComment,
	saveReply,
	saveTidpOverview,
	updateExternalStakeholdersValue,
	updateInternalStakeholdersValue,
	updateOwnersValue,
	updateTidpOverview,
	updateTIDPStatus,
} from './actions'
import { tidpOverviewActions, tidpOverviewConstans } from './index'

interface DocumentComment {
	type: string
	comment: Comment
	recordBy: string
	recordAt: Date
	status: string
	tagCode: string
	code: string
	replies: IReply[]
	documentTagCode: string
	disciplineTagCode: string
}

export const updateTidpOverviewEpic: AppEpicDeprecated<ReturnType<typeof updateTidpOverview>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.UPDATE_TIDP_OVERVIEW)),
		withLatestFrom(state$),
		mergeMap(([action]) => {
			return fromPromise(saveAsset(action.payload.data)).pipe(
				switchMap(() => {
					if (action.payload.isLast && action.payload.isLast.isLast) {
						return action.payload.isLast.action
					}
					return EMPTY
				}),
			)
		}),
	)

export const updateTIDPStatusEpic: AppEpicDeprecated<ReturnType<typeof updateTIDPStatus>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.UPDATE_TIDP_STATUS)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const tagCode: any = window.location.href.substring(window.location.href.lastIndexOf('/') + 1)

			const updateTidpStatus = {
				action_name: action.payload.action_name,
				task_id: action.payload.task_id,
				action_input_parameters: {
					contract: state.users.contract.contract,
					tag_code: tagCode,
				},
			}
			return concat(
				of(tidpOverviewActions.setActionInProgress(true)),
				fromPromise(PostQuery(updateTidpStatus)).pipe(
					switchMap(() => {
						if (action.payload.comment) {
							toast.info('Status updated')
							return concat(
								of(tidpOverviewActions.setActionInProgress(false)),
								of(
									tidpOverviewActions.saveNewComment(
										action.payload.comment,
										window.location.href.substring(window.location.href.lastIndexOf('/') + 1),
									),
								),
								of(tidpOverviewActions.getTidpOverview(tagCode)),
							)
						}
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(
								tidpOverviewActions.getTidpOverview(
									window.location.href.substring(window.location.href.lastIndexOf('/') + 1),
								),
							),
						)
					}),
					catchError((err) => {
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(
								authorizationActions.recallApi({
									callback: tidpOverviewActions.updateTIDPStatus(action.payload),
									errorCode: err.status,
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const updateInternalStakeholdersEpic: AppEpicDeprecated<ReturnType<typeof updateInternalStakeholdersValue>> = (
	action$,
	state$,
) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.UPDATE_INTERNAL_STAKEHOLDERS_VALUE)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const updateInternalStakeholdersBody = {
				action_name: action.payload.action_name,
				task_id: action.payload.task_id,
				action_input_parameters: {
					contract: state.users.contract.contract,
					tag_code: action.payload.tag_code,
					'Internal Stakeholders': action.payload.internalStakeholders,
				},
			}
			return concat(
				of(tidpOverviewActions.setActionInProgress(true)),
				fromPromise(PostQuery(updateInternalStakeholdersBody)).pipe(
					switchMap(() => {
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(tidpOverviewActions.getTidpOverview(action.payload.tag_code)),
						)
					}),
					catchError((err) => {
						toast.error('Error while updating SCS Lead Reviewer')
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.updateInternalStakeholdersValue(action.payload),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const duplicateTidpEpic: AppEpicDeprecated<ReturnType<typeof duplicateTidp>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.DUPLICATE_TIDP)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const duplicateTidpBody = {
				action_name: action.payload.action_name,
				task_id: action.payload.task_id,
				action_input_parameters: {
					contract: state.users.contract.contract,
					tag_code: action.payload.tag_code,
				},
			}
			return concat(
				of(tidpOverviewActions.setActionInProgress(true)),
				fromPromise(PostQuery(duplicateTidpBody)).pipe(
					switchMap((response) => {
						browserHistory.push(`/overview/${response.action_data}`)
						return concat(of(tidpOverviewActions.setActionInProgress(false)))
					}),
					catchError((err) => {
						toast.error(err?.response?.data?.Error ?? 'Error while duplicating TIDP')
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.duplicateTidp(action.payload),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const addAnotherRevisionEpic: AppEpicDeprecated<ReturnType<typeof addAnotherRevision>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.ADD_ANOTHER_REVISION)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const addAnotherRevisionBody = {
				action_name: action.payload.action_name,
				task_id: action.payload.task_id,
				action_input_parameters: {
					contract: state.users.contract.contract,
					tag_code: action.payload.tag_code,
				},
			}
			return concat(
				of(tidpOverviewActions.setActionInProgress(true)),
				fromPromise(PostQuery(addAnotherRevisionBody)).pipe(
					switchMap((response) => {
						return concat(
							of(
								tidpOverviewActions.setAnotherRevision({
									revision: response.action_data.revision,
									tidpNumber: response.action_data.tidp_number,
								}),
							),
							of(tasksActionsElementActions.getTaskActions({ tagCode: action.payload.tag_code })),
							of(tidpOverviewActions.setActionInProgress(false)),
						)
					}),
					catchError((err) => {
						toast.error(err.response && err.response.Error ? err.response.Error : 'Error while creating revision')
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.addAnotherRevision(action.payload),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const updateExternalStakeholdersEpic: AppEpicDeprecated<ReturnType<typeof updateExternalStakeholdersValue>> = (
	action$,
	state$,
) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.UPDATE_EXTERNAL_STAKEHOLDERS_VALUE)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const updateExternalStakeholdersBody = {
				action_name: action.payload.action_name,
				task_id: action.payload.task_id,
				action_input_parameters: {
					contract: state.users.contract.contract,
					tag_code: action.payload.tag_code,
					'External Stakeholders': action.payload.externalStakeholders,
				},
			}
			return concat(
				of(tidpOverviewActions.setActionInProgress(true)),
				fromPromise(PostQuery(updateExternalStakeholdersBody)).pipe(
					switchMap(() => {
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(tidpOverviewActions.getTidpOverview(action.payload.tag_code)),
						)
					}),
					catchError((err) => {
						toast.error('Error while updating Reviewers')
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.updateExternalStakeholdersValue(action.payload),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const updateOwnersEpic: AppEpicDeprecated<ReturnType<typeof updateOwnersValue>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.UPDATE_OWNERS_VALUE)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const updateOwnersBody = {
				action_name: action.payload.action_name,
				task_id: action.payload.task_id,
				action_input_parameters: {
					contract: state.users.contract.contract,
					tag_code: action.payload.tag_code,
					'TIDP Owner': action.payload.owners,
				},
			}
			return concat(
				of(tidpOverviewActions.setActionInProgress(true)),
				fromPromise(PostQuery(updateOwnersBody)).pipe(
					switchMap(() => {
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(tidpOverviewActions.getTidpOverview(action.payload.tag_code)),
						)
					}),
					catchError((err) => {
						toast.error('Error while updating TIDP Owner')
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.updateOwnersValue(action.payload),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const refreshTidpNumberEpic: AppEpicDeprecated<ReturnType<typeof refreshTidpNumber>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.REFRESH_TIDP_NUMBER)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const updatedNumberRequest = {
				action_name: action.payload.action_name,
				task_id: action.payload.task_id,
				action_input_parameters: {
					contract: state.users.contract.contract,
					tag_code: action.payload.tag_code,
				},
			}
			const tidpStatus = state.tidpOverview.tidpNavTabs.map((item: any) =>
				item.name === 'Overview'
					? {
							...item,
							tabs: item.tabs.map((el: any) => (el.name !== 'TIDP Number' ? el : { ...el, status: 'In Progress' })),
					  }
					: item,
			)
			return concat(
				of(tidpOverviewActions.setNavNumberStatus(tidpStatus)),
				of(tidpOverviewActions.setActionInProgress(true)),
				fromPromise(PostQuery(updatedNumberRequest)).pipe(
					switchMap(() => {
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(tidpOverviewActions.getTidpStatusSilent(action.payload.tag_code)),
						)
					}),
					catchError((err) => {
						toast.error('Error while catching Tidp number')
						return concat(
							of(tidpOverviewActions.setActionInProgress(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.refreshTidpNumber(action.payload),
								}),
							),
						)
					}),
				),
			)
		}),
	)

const tidpNavStatus = (state: any, status: string) => {
	const tidpStatus = state.tidpOverview.tidpNavTabs.map((item: any) =>
		item.name === 'Overview'
			? {
					...item,
					tabs: item.tabs.map((el: any) => (el.name !== 'TIDP Number' ? el : { ...el, status })),
			  }
			: item,
	)
	return tidpStatus
}

export const getTIDPStatusEpic: AppEpicDeprecated<ReturnType<typeof getTidpStatus>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.GET_TIDP_STATUS)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			return concat(
				of(tidpOverviewActions.setNavNumberStatus(tidpNavStatus(state, 'In Progress'))),
				fromPromise(getTIDPData(action.payload)).pipe(
					switchMap((response) => {
						if (response.results && response.results.length > 0) {
							if (response.results[0].status.toLowerCase() === 'in progress') {
								return of(tidpOverviewActions.getTidpStatusSilent(action.payload))
							}
							return of(tidpOverviewActions.setNavNumberStatus(tidpNavStatus(state, response.results[0].status)))
						}
						return EMPTY
					}),
					catchError((err) => {
						return concat(
							of(controlsActions.handleIsLoading(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.getTidpStatus(action.payload),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const getTIDPStatusSilentEpic: AppEpicDeprecated<ReturnType<typeof getTidpStatusSilent>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.GET_TIDP_STATUS_SILENT)),
		withLatestFrom(state$),
		delay(5000),
		switchMap(([action, state]) => {
			return concat(
				fromPromise(getTIDPData(action.payload)).pipe(
					switchMap((response) => {
						if (response.results && response.results.length > 0) {
							if (response.results[0].status.toLowerCase() === 'in progress') {
								return of(tidpOverviewActions.getTidpStatusSilent(action.payload))
							}
							if (response.results[0].status.toLowerCase() === 'done') {
								return of(tidpOverviewActions.getTidpOverview(action.payload))
							}
							return of(tidpOverviewActions.setNavNumberStatus(tidpNavStatus(state, response.results[0].status)))
						}
						return EMPTY
					}),
					catchError((err) => {
						return concat(
							of(controlsActions.handleIsLoading(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.getTidpStatusSilent(action.payload),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const saveTidpOverviewEpic: AppEpicDeprecated<ReturnType<typeof saveTidpOverview>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.SAVE_TIDP_OVERVIEW)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const disciplines = state.tidpOverview.rowCells
			const updatedList = disciplines
				.filter((discipline: any) => {
					const uniqueItems = lodash.uniqBy(
						[
							...discipline.originalSelectedOwner,
							...discipline.nominatedOwners.map((el: any) => ({ value: el, label: el })),
						],
						'label',
					)

					const disciplineToCompare = discipline.selectedOwner
						.map((item: any) => lodash.omit(item, ['isClearDisable', 'backgroundColor']))
						.sort((a: any, b: any) => (a.value < b.value ? -1 : 1))
					const uniqToCompare = uniqueItems
						.map((item: any) => lodash.omit(item, ['isClearDisable', 'backgroundColor']))
						.sort((a, b) => (a.value < b.value ? -1 : 1))

					return (
						!lodash.isEqual(disciplineToCompare, uniqToCompare) ||
						discipline.originalIsRequired !== discipline.isRequired
					)
				})
				.map((el: any) => {
					return {
						tag_code: el.tagCode,
						'DIDP Required': el.isRequired,
						'Nominated Owners': el.selectedOwner
							.filter(
								(item: { label: string }) =>
									el.originalSelectedOwner.filter((element: { label: string }) => element.label === item.label)
										.length === 0,
							)
							.map((item: { label: string }) => item.label),
					}
				})

			const newDisciplinesList = action.payload.newDisciplines.map((item: any) => ({
				'DIDP Name': item.label.id.value,
				'DIDP Required': item.required,
				'Nominated Owners': item.owner.map((user: { value: string }) => user.value),
			}))

			const newUpdatedList = [...newDisciplinesList, ...updatedList]

			const updateDisciplines = {
				action_name: action.payload.task_name,
				task_id: action.payload.task_id,
				action_input_parameters: {
					contract: state.users.contract.contract,
					tag_code: action.payload.tidpId,
					didps: newUpdatedList,
				},
			}

			return concat(
				of(tidpOverviewActions.isSavingOverview(true)),
				fromPromise(PostQuery(updateDisciplines)).pipe(
					switchMap((response) => {
						toast.success('Overview updated successfully')
						const newDIDPs =
							response && response.action_data && response.action_data.length > 0
								? response.action_data.map((item: any, index: number) => {
										const didp = item.attribute
										return {
											id: state.tidpOverview.rowCells.length + index + 1,
											nominatedOwners: didp['Nominated Owners'],
											actions: [],
											label: didp['DIDP Name'],
											activeComments: 0,
											inactiveComments: 0,
											isOkToSent: true,
											openCloseComments: '0/0',
											isRequired: didp['DIDP Required'] === 'yes',
											originalIsRequired: didp['DIDP Required'] === 'yes',
											selectedOwner: didp['Nominated Owners'].map((value: string) => ({ value, label: value })),
											originalSelectedOwner:
												didp['DIDP Owner'] && didp['DIDP Owner'].length > 0
													? didp['DIDP Owner'].map((el: string) => ({ value: el, label: el }))
													: [],
											status: didp['DIDP Status'],
											commentContent: '',
											tagCode: item.tag_code,
											deliverables: [],
										}
								  })
								: []
						return concat(
							of(tidpOverviewActions.setNewDiscipline([...state.tidpOverview.rowCells, ...newDIDPs])),
							of(tidpOverviewActions.isSavingOverview(false)),
						)
					}),
					catchError((err) => {
						toast.error('Error while updated TIDP Overview')
						return concat(
							of(tidpOverviewActions.isSavingOverview(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.saveTidpOverview(action.payload),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const getTidpOverviewHistoryEpic: AppEpicDeprecated<ReturnType<typeof getTidpHistory>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.GET_TIDP_OVERVIEW_HISTORY)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			return fromPromise(GetHistory(state.users.contract.contract, action.payload)).pipe(
				switchMap((response) => {
					const historyElements = response?.results
						.map((item: { executed_by: string; execution_time: Date; action: string }) => ({
							name: item.executed_by.substring(0, item.executed_by.indexOf('@')),
							date: item.execution_time,
							history: item.action,
						}))
						.sort((one: any, two: any) => (new Date(one.date) < new Date(two.date) ? 1 : -1))
					return of(tidpOverviewActions.setTidpHistory(historyElements))
				}),
				catchError((err) => {
					return of(
						authorizationActions.recallApi({
							errorCode: err.status,
							callback: tidpOverviewActions.getTidpHistory(action.payload),
						}),
					)
				}),
			)
		}),
	)

export const getListOfDisciplinesEpic: AppEpicDeprecated<ReturnType<typeof getListOfDisciplines>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.GET_LIST_OF_DISCIPLINES)),
		withLatestFrom(state$),
		switchMap(([, state]) => {
			return fromPromise(GetDisciplines(state.users.contract.contract)).pipe(
				switchMap((response) => {
					const disciplineType = response.class[0].attributes.filter(
						(item: { attribute_name: string }) => item.attribute_name === 'Discipline Type',
					)

					const supportFunctionType = response.class[0].attributes.filter(
						(item: { attribute_name: string }) => item.attribute_name === 'Support Function Type',
					)
					const disciplines = {
						disciplineType:
							disciplineType.length > 0
								? disciplineType[0].predetermined_list.map((item: string) => ({ value: item, label: item }))
								: [],
						supportFunctionType:
							supportFunctionType.length > 0
								? supportFunctionType[0].predetermined_list.map((item: string) => ({ value: item, label: item }))
								: [],
					}
					return of(tidpOverviewActions.setListOfDisciplines(disciplines))
				}),
				catchError((err) => {
					return of(
						authorizationActions.recallApi({
							errorCode: err.status,
							callback: tidpOverviewActions.getListOfDisciplines(),
						}),
					)
				}),
			)
		}),
	)

export const getTidpOverviewEpic: AppEpicDeprecated<ReturnType<typeof getTidpOverview>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.GET_TIDP_OVERVIEW)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			return concat(
				action.payload.silent ? EMPTY : of(controlsActions.handleIsLoading(true)),
				fromPromise(getAssetByTagCode(action.payload.tidpId, state.users.contract.contract, 'TIDP')).pipe(
					switchMap((response) => {
						const comments =
							response.result[0]?.relatedTo
								?.find((relatedTo: any) => relatedTo.class_code === 'Document' && relatedTo.class_name === 'Document')
								?.relatedTo?.map((comment: any) => ({
									...comment,
									replies:
										comment.relatedTo && comment.relatedTo.length > 0
											? comment.relatedTo.map((item: any) => ({
													comment: item.Message,
													recordAt: item['Recorded At'],
													code: item.Code,
													recordBy: item['Recorded By'].substring(0, item['Recorded By'].indexOf('@')),
													tagCode: item.tag_code,
													selections: item.selections,
											  }))
											: [],
								})) || []

						const commentsData = comments.sort(
							(a: { recordAt: Date }, b: { recordAt: Date }) =>
								new Date(b.recordAt).getTime() - new Date(a.recordAt).getTime(),
						)
						if (response.result.length === 0) {
							toast.error('There is no Tidp with this ID')
							browserHistory.push('/tasks-list')
							return EMPTY
						}
						const { attribute } = response.result[0]
						const assetAndWorkPackages = response.result[0].relatedWith
							.filter((item: { class_name: string }) => item.class_name === 'Work Package')
							.map((element: any) => {
								return {
									'Work Package Name': element['Work Package Name'],
									'Work Package Type': element['Work Package Type'],
									'Work Package Number': element['Work Package Number'],
								}
							})

						const technicalLifeCycles = response.result[0].relatedWith.filter(
							(item: { class_name: string }) => item.class_name === 'Technical Lifecycles',
						)

						for (const propName in technicalLifeCycles[0]) {
							if ([null, undefined, 'actions', 'class_name', 'tag_code'].includes(propName)) {
								delete technicalLifeCycles[0][propName]
							}
						}
						const stakeholders = {
							internal: Object.keys(attribute)
								.filter((k: any) => k === 'Internal Stakeholders')
								.map((k: any) => {
									return attribute[k]
								}),
							external: Object.keys(attribute)
								.filter((k: any) => k === 'External Stakeholders')
								.map((k: any) => {
									return attribute[k]
								}),
							owners: Object.keys(attribute)
								.filter((k: any) => k === 'TIDP Owner')
								.map((k: any) => {
									return attribute[k]
								}),
						}
						const contractCode = response.result[0].relatedWith.filter((item: any) => !!item['Section Code'])

						const overviewData = [
							{
								isSelected: true,
								name: 'Overview',
								id: 1,
								tabName: 'TIDP Overview Details',
								tabs: Object.keys(attribute)
									.filter((k: any) => !['External Stakeholders', 'Internal Stakeholders', 'TIDP Stage'].includes(k))
									.map((k: any) => {
										if (k === 'TIDP Title') {
											return {
												name: k,
												value: attribute[k],
												info: 'This title is auto generated from your Work Package.',
											}
										}
										if (k === 'Revision') {
											return { name: k, value: attribute[k] }
										}
										if (k === 'TIDP Number') {
											return {
												name: k,
												value: attribute[k],
												info: 'This number is auto-generated from Assetwise. If an error is shown, please refresh the sync to Assetwise.',
											}
										}
										if (k === 'TIDP Created Date') {
											const targetTime = new Date(new Date(attribute[k]))
											const tzDifference = targetTime.getTimezoneOffset()
											const offsetTime = new Date(targetTime.getTime() - tzDifference * 60 * 1000)

											return { name: k, value: moment(new Date(offsetTime)).format(dateFormat.engHours) }
										}
										if (k === 'TIDP Created By') {
											return { name: k, value: attribute[k].substring(0, attribute[k].indexOf('@')) }
										}
										if (k === 'TIDP Owner') {
											return {
												name: k,
												value: attribute[k].map((item: string) => item.substring(0, item.indexOf('@'))),
											}
										}
										return { name: k, value: attribute[k] }
									})
									.concat([
										{ name: 'SCS Lead Reviewer', value: stakeholders.internal?.[0]?.join(', ') || 'n/a' },
										{ name: 'Reviewers', value: stakeholders.external?.[0]?.join(', ') || 'n/a' },
									]),
							},
							{
								isSelected: false,
								name: 'Asset & Work Packages',
								id: 2,
								tabName: 'TIDP Asset',
								tabs:
									assetAndWorkPackages.length > 0
										? Object.keys(assetAndWorkPackages[0]).map((k) => ({ name: k, value: assetAndWorkPackages[0][k] }))
										: [],
							},
						]
						let technicalLifeCycleCode = ''
						if (technicalLifeCycles[0] && technicalLifeCycles[0]['Technical Lifecycle Stage Code']) {
							technicalLifeCycleCode = technicalLifeCycles[0]['Technical Lifecycle Stage Code']
						}
						let counter = 0
						const disciplineData =
							response.result && response.result[0] && response.result[0].relatedTo
								? response.result[0].relatedTo
										.filter((item: any) => item.class_code === 'DIDP')
										.map((didp: any) => {
											return {
												id: ++counter,
												nominatedOwners: didp['Nominated Owners'] ? didp['Nominated Owners'] : [],
												actions: didp.actions ? didp.actions : [],
												label: didp['DIDP Name'],
												activeComments:
													didp.relatedTo && didp.relatedTo.length > 0
														? didp.relatedTo.filter(
																(el: { class_name: string; Status: string }) =>
																	el.Status === 'Open' && el.class_name === 'Comment',
														  ).length
														: 0,
												inactiveComments:
													didp.relatedTo && didp.relatedTo.length > 0
														? didp.relatedTo.filter(
																(el: { class_name: string; Status: string }) =>
																	el.Status !== 'Open' && el.class_name === 'Comment',
														  ).length
														: 0,
												isOkToSent: true,
												openCloseComments: '0/0',
												isRequired: didp['DIDP Required'] === 'yes',
												originalIsRequired: didp['DIDP Required'] === 'yes',
												selectedOwner:
													didp['DIDP Owner'] && didp['DIDP Owner'].length > 0
														? didp['DIDP Owner'].map((item: string) => ({ value: item, label: item }))
														: [],
												originalSelectedOwner:
													didp['DIDP Owner'] && didp['DIDP Owner'].length > 0
														? didp['DIDP Owner'].map((item: string) => ({ value: item, label: item }))
														: [],
												status: didp['DIDP Status'],
												commentContent: '',
												tagCode: didp.tag_code,
												deliverables:
													didp.relatedWith &&
													didp.relatedWith.filter((item: { class_name: string }) => item.class_name === 'Document')
														.length > 0
														? didp.relatedWith.filter((item: { class_name: string }) => item.class_name === 'Document')
														: [],
											}
										})
								: [].sort((one: any, two: any) => (one.label > two.label ? 1 : -1))
						return concat(
							of(tidpOverviewActions.getTidpHistory(action.payload.tidpId)),
							of(tidpOverviewActions.setTechnicalLifecycleCode(technicalLifeCycleCode)),
							of(tidpOverviewActions.setTidpOverviewData(overviewData, stakeholders, response.result[0])),
							of(tidpOverviewActions.assignTidpComments(commentsData)),
							of(tidpOverviewActions.setTidpOverviewDisciplines(disciplineData)),
							of(tasksActionsElementActions.getTaskActions({ tagCode: action.payload.tidpId })),
							of(tidpOverviewActions.getTidpStatus(action.payload.tidpId)),
						)
					}),
					catchError((err) => {
						console.error(err)
						return concat(
							of(controlsActions.handleIsLoading(false)),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.getTidpOverview(action.payload.tidpId),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const saveNewCommentTidpOverviewEpic: AppEpicDeprecated<ReturnType<typeof saveNewComment>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.SAVE_NEW_TIDP_COMMENT)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const username = (state as any).profile!.user.name
			const today = new Date()

			const data = {
				contract: state.users.contract.contract,
				class_code: 'Comment',
				relations: [
					{
						tag_code: action.payload[2],
					},
				],
				attribute: {
					Message: action.payload[0],
					Head: true,
					Code: action.payload[3],
					'Recorded At': moment(today).zone('+00:00').format(dateFormat.apiFormat),
					'Recorded By': username,
					Status: action.payload[4],
				},
			}
			return concat(
				of(tidpOverviewActions.isSavingNewCommentTidpOverview(true)),
				fromPromise(saveNewAssetComment(data)).pipe(
					switchMap(() => {
						toast.info('Comment added.')
						return concat(
							of(tidpOverviewActions.isSavingNewCommentTidpOverview(false)),
							of(tidpOverviewActions.getTidpOverview(action.payload[1], true)),
							of(tidpOverviewActions.clearCommentData()),
						)
					}),
					catchError((err) => {
						if (err.status === 500) {
							return concat(
								of(tidpOverviewActions.isSavingNewCommentTidpOverview(false)),
								of(tidpOverviewActions.clearCommentData()),
								of(tidpOverviewActions.getTidpOverview(action.payload[1])),
							)
						}
						return concat(
							of(tidpOverviewActions.isSavingNewCommentTidpOverview(false)),
							of(tidpOverviewActions.clearCommentData()),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.saveNewComment(
										action.payload[0],
										action.payload[1],
										action.payload[2],
										action.payload[3],
										action.payload[4],
									),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export const saveNewTIDPReplyEpic: AppEpicDeprecated<ReturnType<typeof saveReply>> = (action$, state$) =>
	action$.pipe(
		filter(isOfType(tidpOverviewConstans.SAVE_TIDP_REPLY)),
		withLatestFrom(state$),
		switchMap(([action, state]) => {
			const username = (state as any).profile!.user.name
			const data = {
				contract: state.users.contract.contract,
				class_code: 'Comment',
				attribute: {
					Message: action.payload[0],
					'Recorded At': moment(new Date()).zone('+00:00').format(dateFormat.apiFormat),
					'Recorded By': username,
				},
				relations: [{ tag_code: action.payload[1] }],
			}

			return concat(
				of(tidpOverviewActions.isSavingNewCommentTidpOverview(true)),
				fromPromise(saveNewAssetComment(data)).pipe(
					switchMap(() => {
						toast.info('Reply added.')
						return concat(
							of(tidpOverviewActions.isSavingNewCommentTidpOverview(false)),
							of(tidpOverviewActions.getTidpOverview(action.payload[2], true)),
							of(tidpOverviewActions.clearCommentData()),
						)
					}),
					catchError((err) => {
						if (err.status === 500) {
							return concat(
								of(tidpOverviewActions.isSavingNewCommentTidpOverview(false)),
								of(tidpOverviewActions.clearCommentData()),
								of(tidpOverviewActions.getTidpOverview(action.payload[2])),
							)
						}
						return concat(
							of(tidpOverviewActions.isSavingNewCommentTidpOverview(false)),
							of(tidpOverviewActions.clearCommentData()),
							of(
								authorizationActions.recallApi({
									errorCode: err.status,
									callback: tidpOverviewActions.saveReply(
										action.payload[0],
										action.payload[1],
										action.payload[2],
										action.payload[3],
									),
								}),
							),
						)
					}),
				),
			)
		}),
	)

export default combineEpics(
	saveTidpOverviewEpic,
	saveNewTIDPReplyEpic,
	getTidpOverviewEpic,
	updateTidpOverviewEpic,
	saveNewCommentTidpOverviewEpic,
	updateExternalStakeholdersEpic,
	updateInternalStakeholdersEpic,
	updateOwnersEpic,
	updateTIDPStatusEpic,
	getTidpOverviewHistoryEpic,
	getListOfDisciplinesEpic,
	refreshTidpNumberEpic,
	getTIDPStatusEpic,
	getTIDPStatusSilentEpic,
	duplicateTidpEpic,
	addAnotherRevisionEpic,
)
